(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enquiry-form"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
   document.querySelectorAll('.newsletter-modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("newsletter-data-modal-toggle");
          var modal = document.querySelector('.promo-modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".promo-modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
    document.getElementById('custom-ajax-search-input').addEventListener('keyup', function() {
    var searchQuery = this.value.toLowerCase();
    var products = document.querySelectorAll('.loc-grid-item');
    if (searchQuery.length > 0) {
        products.forEach(function(product) {
            var productTitle = product.querySelector('.loc-title').textContent.toLowerCase();
            if (productTitle.indexOf(searchQuery) > -1) {
                product.style.display = '';
            } else {
                product.style.display = 'none';
            }
        });
    } else {
        products.forEach(function(product) {
            product.style.display = '';
        });
    }
});

/* Alphabets filter */
document.querySelectorAll('.alphabet-link').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelectorAll('.alphabet-link').forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        const selectedLetter = this.getAttribute('data-letter');
        const gridItems = document.querySelectorAll('.loc-grid-item');
        let hasVisibleItems = false;

        gridItems.forEach(item => {
            const locTitle = item.querySelector('.title-br').textContent.trim().toUpperCase();
            if (locTitle.startsWith(selectedLetter)) {
                item.classList.remove('hidden');
                item.style.display = 'flex';
                hasVisibleItems = true;
            } else {
                item.classList.add('hidden');
                item.style.display = 'none';
            }
        });

        // Show clear filter button even if no items match the letter
        document.getElementById('clearFilter').style.display = 'inline-block';
    });
});

document.getElementById('clearFilter').addEventListener('click', function() {
    const gridItems = document.querySelectorAll('.loc-grid-item');
    gridItems.forEach(item => {
        item.classList.remove('hidden');
        item.style.display = 'flex';
    });

    // Hide the clear filter button after resetting
    this.style.display = 'none';

    // Remove active class from alphabet links
    document.querySelectorAll('.alphabet-link').forEach(link => link.classList.remove('active'));
});


  } catch(e) { console.error(e); }
})();
})();
